
import { defineComponent } from "vue";
import Account from "@/components/Account.vue";

export default defineComponent({
  name: "NavBar",
  components: { Account },
});
